import React, { useState } from 'react';

import FileViewModal from '@features/assets/components/CommonComponents/FileViewModal';

const SketchItem = ({ sketch, onDownloadImages, onEdit, onDeleteClick }) => {
	const [selectedSketchId, setSelectedSketchId] = useState(null);
	return (
		<>
			<div className="single-design-card with-editable">
				<div className="card-top">
					<div className="edit-items">
						<div className="select-and-edit d-flex justify-content-between">
							<div></div>
							<div className="option">
								<div className="dropdown">
									<button
										className="btn btn-default dropdown-toggle"
										type="button"
										id="menu1"
										data-toggle="dropdown"
										aria-expanded="false"
									>
										<img src={`${process.env.PUBLIC_URL}/icons/more_icon.svg`} alt />
									</button>
									<ul
										className="dropdown-menu dropdown-menu-right shadow-lg"
										role="menu"
										aria-labelledby="menu1"
										x-placement="bottom-end"
									>
										<li>
											<span onClick={() => onEdit(sketch?.id)}>Edit</span>
										</li>
										<li>
											<span onClick={() => onDownloadImages(sketch?.id)}>
												Download sketch
											</span>
										</li>
										<li>
											<span
												className="red"
												onClick={() => {
													onDeleteClick(sketch?.id);
												}}
											>
												Delete
											</span>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<img
						src={
							sketch?.documentResponseList?.length > 0 &&
							sketch.documentResponseList.find((doc) => doc.docType === 'ASSETS_IMAGE_S1')
								?.docUrl
								? sketch.documentResponseList.find((doc) => doc.docType === 'ASSETS_IMAGE_S1')
										?.docUrl
								: `${process.env.PUBLIC_URL}/images/sketch-dress.png`
						}
						alt="card-image"
						onClick={() => setSelectedSketchId(sketch?.id)}
					/>
				</div>
				<div className="card-content" onClick={() => setSelectedSketchId(sketch?.id)}>
					<h3 className="semibold-12 weight-600 design-title gray_dark_01">
						{sketch?.referenceNumber}
					</h3>
					<div className="card-info d-flex justify-content-between">
						<ul className="list-item-with-dot">
							{sketch?.marketResponse?.name && (
								<li className="regular-12 gray_dark_02 text-uppercase">
									{sketch?.marketResponse?.name}
								</li>
							)}
							{sketch?.categoryResponse?.name && (
								<li className="regular-12 gray_dark_02 text-uppercase">
									{sketch?.categoryResponse?.name}
								</li>
							)}
						</ul>
					</div>
					{sketch?.fittingTypeTagResponse?.text && (
						<p className="regular-12 gray_dark_02 text-uppercase">
							{sketch?.fittingTypeTagResponse?.text}
						</p>
					)}
				</div>
				{selectedSketchId && (
					<FileViewModal
						viewType={'SKETCH'}
						selectedItemId={selectedSketchId}
						onClose={() => setSelectedSketchId(null)}
					/>
				)}
			</div>
		</>
	);
};

export default SketchItem;
